module.exports = __webpack_public_path__ + "img/ranking-icon.15512cb.svg";